import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsFramesModal } from "../../../redux/slices/modals";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import { FrameItem } from "../../../page/ThirdScreen/qrSettings/framesQr/QrFrameItems";
import useFrames from "../../../hooks/useFrames";
import Accordion from "react-bootstrap/Accordion";
import classNames from "classnames";
import QrFrameWrapper from "../../../page/ThirdScreen/qrSettings/framesQr/QrFrameWrapper";
import {
  qrFrame,
  qrFrameTransform,
  qrFrameTransformText,
  qrSetFrames,
} from "../../../redux/slices/qrFrames";
import QrModalPreview from "./QrModalPreview";
import PreMadeFrameItem from "../../../page/ThirdScreen/qrSettings/framesQr/preMadeFrames/PreMadeFrameItem";
import { setActivePremadeTemplateId } from "../../../redux/slices/preMadeTemplates";
import { qrSetSettings } from "../../../redux/slices/qrSettings";
import { qrSetText } from "../../../redux/slices/qrTextSettings";
import { setQrOptions } from "../../../redux/slices/qrOptions";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

const ModalFrames = () => {
  const { isFramesModal, lang, preTempates } = useSelector((state) => ({
    isFramesModal: state.modals.isFramesModal,
    lang: state.changeLang.language.modalFrames,
    preTempates: state.preMadeTemplates.preTempates,
  }));
  const dispatch = useDispatch();
  const { frameConfigs, framesCategories } = useFrames();
  const { isApiDocLocation } = useCurrentLocation();

  const [selectedFrame, setSelectedFrame] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleClose = () => {
    dispatch(setIsFramesModal(false));
    setSelectedFrame(null);
    setSelectedTemplate(null);
  };

  const titles = [
    lang[4],
    lang[5],
    lang[6],
    lang[7],
    lang[8],
    lang[9],
    lang[10],
    lang[11],
    lang[12],
    lang[13],
    lang[14],
    lang[15],
    lang[16],
    lang[17],
    lang[18],
    lang[19],
    lang[20],
    lang[21],
    lang[22],
    lang[23],
    lang[24],
    lang[25],
    lang[26],
    lang[27],
    lang[28],
    lang[29],
    lang[30],
    lang[31],
    lang[32],
    lang[33],
    lang[34],
    lang[35],
    lang[36],
  ];

  const handleApply = () => {
    if (selectedTemplate) {
      dispatch(setActivePremadeTemplateId(selectedTemplate.id));
      dispatch(qrSetFrames(selectedTemplate.qrFrames));
      dispatch(qrSetSettings(selectedTemplate.qrSettings));
      dispatch(qrSetText(selectedTemplate.qrText));
      dispatch(setQrOptions(selectedTemplate.qrOptions));
    } else if (selectedFrame) {
      dispatch(qrFrame(selectedFrame.name));
      dispatch(qrFrameTransform(selectedFrame.transformQr));
      dispatch(qrFrameTransformText(selectedFrame.transformFrameText));
    }
    handleClose();
  };

  const selectFrameHandle = (item) => {
    setSelectedFrame(item);
    setSelectedTemplate(null);
  };

  const handleTemplateBtn = (template) => {
    setSelectedFrame(null);
    setSelectedTemplate(template);
  };

  return (
    <Modal
      show={isFramesModal}
      onHide={handleClose}
      centered
      size="lg"
      scrollable
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="text-capitalize">{lang[0]}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} md={8}>
            <Accordion
              defaultActiveKey={["preMade", ...framesCategories]}
              alwaysOpen
              flush
            >
              {preTempates.length ? (
                <Accordion.Item eventKey={"preMade"} className="border-0">
                  <Accordion.Header>
                    <div className="text-dark fw-bold fs-8 text-capitalize">
                      {lang[37]}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row className="g-2 g-lg-3">
                      {preTempates.map((template) => (
                        <Col xs={3} md={2} key={template.id}>
                          <PreMadeFrameItem
                            template={template}
                            handleTemplateBtn={handleTemplateBtn}
                            selectedId={selectedTemplate?.id}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null}
              {framesCategories
                .slice(1)
                .map((category, index) => (
                  <Accordion.Item
                    key={category}
                    eventKey={category}
                    className="border-0"
                  >
                    <Accordion.Header>
                      <div className="text-dark fw-bold fs-8 text-capitalize">
                        {titles[index]}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Row className="g-2 g-lg-3">
                        {frameConfigs
                          .filter((item) => item.categoryId === index + 1)
                          .map((item) => (
                            <Col xs={3} md={2} key={item.name}>
                              <FrameItem
                                onClick={() => selectFrameHandle(item)}
                                className={classNames(
                                  "d-flex justify-content-center align-items-center border rounded-1 p-2",
                                  {
                                    "border-primary":
                                      selectedFrame?.name === item.name,
                                    "border-border-gray":
                                      selectedFrame?.name !== item.name,
                                  }
                                )}
                              >
                                <QrFrameWrapper
                                  frame={item.name}
                                  frameColor={"#727271"}
                                />
                              </FrameItem>
                            </Col>
                          ))}
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                ))
                .reverse()}
            </Accordion>
          </Col>
          <Col xs={4} className="d-none d-md-block">
            <aside className="sticky-top mx-0">
              <div className="border border-1 rounded border-border-gray p-2">
                <QrModalPreview
                  selectedFrame={selectedFrame}
                  template={selectedTemplate}
                />
              </div>
              {isApiDocLocation && (
                <div className="mt-2 text-center fw-bold">
                  {selectedFrame?.name}
                </div>
              )}
            </aside>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="d-block border-0">
        <Row className="gx-3 gy-2 justify-content-lg-between">
          <Col xs={8} md={12} className="d-flex align-items-center">
            <Row className="gx-3 gy-2 justify-content-lg-between w-100">
              <Col xs={12} lg={4} className="order-1 order-lg-0 px-0">
                <Button
                  variant="outline-dark"
                  className="w-100 py-2 py-md-3 h-100 d-flex align-items-center justify-content-center"
                  onClick={handleClose}
                >
                  {lang[2]}
                </Button>
              </Col>
              {!isApiDocLocation && (
                <Col xs={12} lg={4} className="px-0">
                  <Button
                    className={classNames("w-100 fw-bold py-2 py-md-3 h-100", {
                      "bg-border-gray border-border-gray":
                        !selectedTemplate && !selectedFrame,
                    })}
                    disabled={!selectedTemplate && !selectedFrame}
                    onClick={handleApply}
                  >
                    {lang[3]}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
          <Col
            xs={4}
            className="d-flex justify-content-center align-items-center flex-column d-md-none"
          >
            <div style={{ maxWidth: "95px" }}>
              <QrModalPreview
                selectedFrame={selectedFrame}
                template={selectedTemplate}
              />
            </div>
            {isApiDocLocation && (
              <div className="text-center fw-bold text-break fs-7">
                {selectedFrame?.name}
              </div>
            )}
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalFrames;
